import { render } from "./FormApat.vue?vue&type=template&id=a8145098&scoped=true"
import script from "./FormApat.vue?vue&type=script&lang=js"
export * from "./FormApat.vue?vue&type=script&lang=js"

import "./FormApat.vue?vue&type=style&index=0&id=a8145098&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8145098"]])

export default __exports__